<template>
  <transition
    v-if="slotPassed"
    enter-active-class="transition ease-out duration-200"
    enter-from-class="opacity-0 -translate-y-1"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition ease-in duration-150"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 -translate-y-1"
  >
    <div v-show="openMenu || false" class="absolute z-50 -ml-8 transform w-screen max-w-xs" :class="maxWidth">
      <div class="rounded-b-md shadow-md">
        <div class="rounded-b-md overflow-hidden border-t border-gray-100">
          <div class="z-20 relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8" :class="gridColumns">
            <slot />
          </div>
          <!-- <div class="p-5 bg-gray-50 sm:p-8">
                <slot #footer />
              </div> -->
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    columns: {
      type: Number,
      default: 2
    },
    openMenu: {
      type: Boolean,
      default: false
    },
    slotPassed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    maxWidth() {
      switch (this.columns) {
        case 2:
          return `lg:max-w-md`
          break

        default:
          return `lg:max-w-2xl`
          break
      }
    },
    gridColumns() {
      return `lg:grid-cols-${this.columns}`
    }
  }
}
</script>

<style></style>
